import React from 'react';
import { motion } from 'framer-motion';
import { staggerContainer, staggerItem } from '../../utils/animations';
import Section from '../../Components/common/Section';
import AnimatedCounter from '../../Components/common/AnimatedCounter';

const StatsSection = () => {
  const stats = [
    { number: 100, suffix: '+', label: 'Projects Delivered' },
    { number: 50, suffix: '+', label: 'Happy Clients' },
    { number: 5, suffix: '+', label: 'Years Experience' },
    { number: 98, suffix: '%', label: 'Client Satisfaction' },
  ];

  return (
    <Section background="gradient">
      <motion.div
        variants={staggerContainer}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true, amount: 0.3 }}
        className="text-center"
      >
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div key={index} variants={staggerItem} className="text-center">
              <div className="text-4xl md:text-5xl lg:text-6xl font-bold mb-2">
                <AnimatedCounter target={stat.number} suffix={stat.suffix} />
              </div>
              <p className="text-lg md:text-xl text-gray-200">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </Section>
  );
};

export default StatsSection;
